export enum ActivityResultsActions {
  CLONE    = 'clone',
  DETAILS  = 'details', // Activity Info
  FAVORITE = 'favorite',
  PIN      = 'pin',
  SHARE    = 'share'
}
